import axios from "axios";
import API_BASE_URL from "../config/apiConfig";
import api from "./api";

export const getCompanyPaymentDetails = async () => {
  const { data } = await api.get("/api/admin/company-payment-details");
  return data || {};
};

export const saveCompanyPaymentDetails = async (details) => {
  const { data } = await api.put("/api/admin/company-payment-details", details);
  return data;
};

export const uploadCompanyPaymentQr = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await axios.post(
    `${API_BASE_URL}/api/admin/company-payment-details/qr/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data;
};

/**
 * The QR bytes, fetched through our own API rather than the CDN. The CDN serves the image fine to
 * an <img> tag but sends no CORS headers, so a direct fetch of it is blocked and the clipboard
 * never gets the data. This route carries the same auth and CORS as every other admin call.
 */
export const fetchCompanyPaymentQrBlob = async () => {
  const { data } = await api.get("/api/admin/company-payment-details/qr", { responseType: "blob" });
  return data;
};

/**
 * The lines a customer needs in order to pay us, in the order they are read. Blank fields drop
 * out rather than showing "-", so a half-filled record still produces a sane message.
 */
export const companyPaymentLines = (details) => {
  if (!details) return [];
  return [
    ["Account Holder", details.accountHolder],
    ["Account Number", details.accountNumber],
    ["IFSC", details.ifsc],
    ["Branch", details.branch],
    ["Account Type", details.accountType],
    ["UPI Number", details.upiNumber],
    ["UPI ID", details.upiId],
    ["Name", details.upiName],
  ]
    .filter(([, value]) => String(value || "").trim())
    .map(([label, value]) => `${label}: ${String(value).trim()}`);
};
